/**
 * Calculate discount based on price and compare at price
 * 
 * @param {Object} price
 * @param {string} price.amount
 * @param {string} price.currencyCode
 * @param {Object} compareAtprice
 * @param {string} compareAtprice.amount
 * @param {string} compareAtprice.currencyCode
 * @param {number} [quantity]
 *  @param {Array} discountAllocations
 * @returns {Object}
 */
// 根据优惠价格和原价计算折扣

import { useMoney } from '@shopify/hydrogen-react';
import { useFormatConvertedPrice } from "@/hooks/shopify-hooks/useFormattedPrice";

const useCartSalePrice = (price, compareAtprice, quantity = 1, discountAllocations) => {
  const { amount: priceAmount, currencyCode } = price;
  const { amount: compareAtpriceAmount } = compareAtprice;
  const compareAtpriceTotal = compareAtpriceAmount * quantity;
  const priceAmountTotal = priceAmount * quantity;
  const differenceAmount = compareAtpriceTotal - priceAmountTotal;
  
  // 计算最终的折扣金额
  let finalDiscountAmount = 0;
  
  if (discountAllocations.length) {
    const { discountedAmount } = discountAllocations[0];
    const discountValue = discountedAmount.amount * 1;
    
    if (differenceAmount <= 0) {
      finalDiscountAmount = discountValue;
    } else {
      finalDiscountAmount = differenceAmount + discountValue;
    }
  } else {
    finalDiscountAmount = differenceAmount;
  }
  
  // 始终调用 useMoney Hook，不管条件如何
  const money = useMoney({
    amount: finalDiscountAmount,
    currencyCode: currencyCode
  });
  
  // 根据条件决定返回值
  if (finalDiscountAmount <= 0) {
    return {
      formattedPrice: null,
      withoutTrailingZeros: null,
    };
  }
  
  return useFormatConvertedPrice(money, currencyCode);
};

export default useCartSalePrice;